import { Routes } from '@angular/router';
import { EditOrganismeComponent } from './pages/edit-organisme/edit-organisme.component';
import { EditAbonnementsComponent } from './pages/edit-abonnements/edit-abonnements.component';
import { ListeOrganismesComponent } from './pages/liste-organismes/liste-organismes.component';

export const ORGANISMES_ROUTE_DATA = {
    role: 'ADMIN || INTERVENANT_ORGANISME_LISTE_LECTURE',
    domaines: ['VIN'],
    menu: {
        icon: 'building',
        libelle: 'menu.administration-organismes'
    }
};
export const ORGANISMES_ROUTES: Routes = [
    { path: '', component: ListeOrganismesComponent },
    { path: 'new', component: EditOrganismeComponent, data: { roles: ['INTERVENANT_ORGANISME_CREATION'] } },
    {
        path: 'edit/:id',
        component: EditOrganismeComponent,
        data: {
           // roles: ['INTERVENANT_ORGANISME_DETAIL_LECTURE', 'INTERVENANT_ORGANISME_MODIFICATION']
        }
    },
    {
        path: 'edit-abonnements/:id',
        component: EditAbonnementsComponent,
        data: {
          //  roles: ['INTERVENANT_ORGANISME_ABONNEMENT_LECTURE', 'INTERVENANT_ORGANISME_ABONNEMENT_ECRITURE']
        }
    }
];
